import { FC, useEffect, useState } from 'react';
import tw from 'twin.macro';
import { mandatoryCheckBox } from '../../InputPatterns';
import { InputProps } from './interface';
import { getUserLocationData } from '../../../../../lib/common/userLocation';
import { UserLocation } from '../../../../../interfaces/city';

const Container = tw.div`relative w-full`;

const Checkbox = tw.input`cursor-pointer`;

const Label = tw.label`
    inline-block pl-8 leading-4 text-xs text-[#3f3f3f] cursor-pointer 
`;

const Anchor = tw.a`text-[#ec3957]`;

const TermsAndCondition: FC<InputProps> = ({ errors, register, isSubmitted, isWhatsappContent = false }) => {
  const id = Math.random();

  const [userCurrentLocation, setUserCurrentLocation] = useState<UserLocation>();

  useEffect(() => {
    async function getUserLocationDetails() {
      let response = await getUserLocationData();
      setUserCurrentLocation(response);
    }
    // getCountriesList
    getUserLocationDetails();
  }, []);

  return (
    <>
      {userCurrentLocation?.region?.id == 3 && (
        // Terms and condition only for COUNTRY CODE 4
        <Container className="group -mb-9">
          {/* Label & input */}
          <Label htmlFor={`mandatory-checkbox-${id}`}>
            <Checkbox
              id={`mandatory-checkbox-${id}`}
              type="checkbox"
              className={` ${isWhatsappContent ? 'mc-form-checkbox' : 'form-checkbox'}`}
              {...register('europe_gdpr_consent', mandatoryCheckBox)}
              hidden
            />
            <span className="absolute left-0"></span>I consent to receive communications by email, SMS, WhatsApp, phone
            and other electronic means from upGrad. See our{' '}
            <Anchor href="https://www.upgrad.com/privacy" target="_blank">
              privacy policy
            </Anchor>{' '}
            and{' '}
            <Anchor href="https://www.upgrad.com/terms" target="_blank">
              terms & conditions
            </Anchor>{' '}
            for your rights under GDPR.
          </Label>
          {/* Error Message Container */}
          <p
            className={`${
              errors?.europe_gdpr_consent && isSubmitted ? 'visible' : 'invisible'
            } text-red-500 text-[12px] px-1`}
          >
            This field is required
          </p>
        </Container>
      )}
    </>
  );
};

export default TermsAndCondition;